export const testCaseByVersionTable = [
  {
    key : "row-select",
    display_name : "",
    _config: {
      type: "checkbox",
      displayInColumn: true,
    },
    cellStyles: {
      width: 0,
    },
    headerStyles: {
      background : "#7593F2",
      color: "#FFFFFF",
      width : "4%",
      "font-weight": 600
    }
  },
  {
    display_name: "Story ID",
    key: "key",
    headerStyles: {
      background: "#7593F2",
      color: "#FFFFFF",
      width: "6%",
      "font-weight": 600,
    },
    _editConfig: {
      type: 'textarea'
    }
  },
  {
    display_name: "Story",
    key: "storydesc",
    headerStyles: {
      background: "#7593F2",
      color: "#FFFFFF",
      "font-weight": 600,
      width: "12%",
    },
    _editConfig: {
      type: 'textarea'
    }
  },
  {
    display_name: "TC ID",
    key: "testCaseId",
    headerStyles: {
      background: "#7593F2",
      color: "#FFFFFF",
      width: "5%",
      "font-weight": 600,
    },
    _editConfig: {
      type: 'textarea'
    }
  },
  {
    display_name: "TC Description",
    key: "testCase",
    headerStyles: {
      background: "#7593F2",
      color: "#FFFFFF",
      "font-weight": 600,
      width: "12%",
    },
    _editConfig: {
      type: 'textarea'
    }
  },
  {
    display_name: "Prerequisites",
    key: "prerequisites",
    type: "orderd-list",
    headerStyles: {
      background: "#7593F2",
      color: "#FFFFFF",
      "font-weight": 600,
      width: "17%",
    },
    _editConfig: {
      type: 'textarea'
    }
  },
  {
    display_name: "Test Steps",
    key: "testScenario",
    type: "orderd-list",
    headerStyles: {
      background: "#7593F2",
      color: "#FFFFFF",
      "font-weight": 600,
      width: "17%",
    },
    _editConfig: {
      type: 'textarea'
    }
  },
  {
    display_name: "Expected Results",
    key: "expectedResult",
    type: "orderd-list",
    headerStyles: {
      background: "#7593F2",
      color: "#FFFFFF",
      "font-weight": 600,
      width: "17%",
    },
    _editConfig: {
      type: 'textarea'
    }
  },
  {
    key: "",
    display_name: "",
    cellStyles: {
      "font-size": "13px",
      width: "50px",
      color: "#FFFFFF"
    },
    headerStyles: {
      background: "#7593F2",
      "font-weight": "600",
      width: "3%",
      color: "#ffffff",
    },
    _config: {
      type: "icon",
      displayInColumn: false,
      isClickable: true,
      value: "edit",
      iconStyles: {
        color: "#686ff1",
        "font-size": "22px",
        cursor: "pointer"
      }
    },
    _editConfig: {
      type: "icon",
      displayInColumn: false,
      isClickable: true,
      value: "check",
      iconStyles: {
        color: "#686ff1",
        "font-size": "26px",
        cursor: "pointer"
      }
    }
  },
  {
    key: "",
    display_name: "",
    cellStyles: {
      "font-size": "13px",
      width: "50px",
      color: "#FFFFFF"
    },
    headerStyles: {
      background: "#7593F2",
      "font-weight": "600",
      width: "3%",
      color: "#ffffff",
    },
    _editConfig: {
      type: "icon",
      displayInColumn: false,
      isClickable: true,
      value: "close",
      iconStyles: {
        color: "#686ff1",
        "font-size": "26px",
        cursor: "pointer"
      }
    }
  }
];
